// extracted by mini-css-extract-plugin
export var cartContainer = "_jm-4";
export var gray = "_jm-1";
export var itemContainer = "_jm-2";
export var itemDetails = "_jm-3";
export var strong = "_jm-0";